import axios from "axios"

const SUPPLY_URL = "https://circsupply.idexo.io"
const PRICE_URL = "https://api.coingecko.com/api/v3/simple/price?ids=idexo-token&vs_currencies=USD"

const config = {
    headers: {
        "Content-Type": "application/json",
        token: localStorage.jwtToken
    }
}

export const api = {
    getCircSupply: async () => {
        try {
            let response = await axios.post(SUPPLY_URL, config)
            return response.data
        } catch (error) {
            console.log(error)
            let response
            return response
        }
    },
    getPrice: async () => {
        try {
            let response = await axios.get(PRICE_URL, config)
            return response.data
        } catch (error) {
            console.log(error)
            let response
            return response
        }
    }
}
